import React from "react";
import point from "../../assets/bulletpoint.svg";
import "./Companies.css";
import wajahost from "../../assets/icons/wajahostals.png";
import valley from "../../assets/icons/valley.png";
import wijha from "../../assets/icons/wijhamakan.png";
import dit from "../../assets/icons/DIT.png";
import waja from "../../assets/icons/wajarealestate.png";
import arktech from "../../assets/icons/arktech.png";
import jasara2 from "../../assets/icons/jasara logo.png";
import panar2 from "../../assets/icons/panar2.png";
import { useTranslation } from "react-i18next";

export default function Companies() {
  const { t, i18n } = useTranslation();

  return (
    <section id="company">
      <div className="companies-container">
        <h2>
          <img src={point} className="point" />
          {t("company")}
          <img src={point} className="point" />
        </h2>
        <div className="companies">
          <a href="https://waja.sa/" target="_blank" rel="noopener noreferrer">
            <img
              src={waja}
              className="company"
              style={{
                width: "130px",
                // marginBottom: "35px",
                // marginLeft: "-40px",
                marginTop: "25px",
                width: "120px",
              }}
            />
          </a>

         
          <a
            href="https://arktec.sa/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={arktech}
              className="company"
              style={{
                width: "150px",
                // marginBottom: "50px",
                marginLeft: "-24px",
                marginTop: "30px",
              }}
            />
          </a>

          <a
            href="https://www.dit.sa/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={dit}
              className="company"
              style={{
                // marginBottom: "30px",
                // marginLeft: "-50px",
                marginTop: "10px",

                width: "180px",
              }}
            />
          </a>

          <a href="https://valie.sa/" rel="noopener noreferrer">
            <img
              src={valley}
              className="valley-company"
              style={{
                width: "100px",

                // marginRight: "-10px",
                marginTop: "20px",
              }}
            />
          </a>

          
          <a href="" rel="noopener noreferrer">
            <img
              src={jasara2}
              className="jasara2-company"
              style={{
                width: "100px",

                // marginRight: "-10px",
                marginTop: "20px",
              }}
            />
          </a>
          
          {/* <a href="#" target="_blank" rel="noopener noreferrer">
            <img
            src={wijha}
              className="company"
              style={{
                marginTop: "10px",
                width: "120px",
              }}
            />
          </a> */}

          {/* its an investment not component */}
          {/* <a
            href="https://hakbah.sa/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={hakbah}
              className="company"
              style={{
                // width: "160px",
                marginBottom: "60px",
                marginLeft: "-20px",
              }}
            />
          </a> */}
        </div>
      </div>
    </section>
  );
}
